/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Customer
 *
 * 1 = ContactCentre
 *
 * 2 = CSI
 *
 * 3 = ManufactureCustomerService
 *
 * 4 = TMO
 *
 * 5 = GoogleReview
 */
export enum ComplainSourceEnum {
  Customer = 0,
  ContactCentre = 1,
  CSI = 2,
  ManufactureCustomerService = 3,
  TMO = 4,
  GoogleReview = 5,
}
